/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ticket_claim_error_generic = () => `Das Ticket konnte nicht auf einen Namen gesetzt werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Veranstalter, falls es weiterhin fehlschlägt.`
